(() => {
  'use strict';
  if (window.__SQ_QUEEN_LIFE_MENU_ROUTE_V1__) return;
  window.__SQ_QUEEN_LIFE_MENU_ROUTE_V1__ = true;

  const DESTINATION = '/collections/queen-life-trending';
  const normalize = (value) => String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();

  const matchesQueenLife = (anchor) => {
    if (!(anchor instanceof HTMLAnchorElement)) return false;
    if (normalize(anchor.textContent) === 'queen life') return true;

    try {
      const url = new URL(anchor.href, window.location.origin);
      return (
        url.origin === window.location.origin &&
        url.pathname.replace(/\/$/, '') === '/search' &&
        normalize(url.searchParams.get('q')) === 'queen life'
      );
    } catch (_) {
      return false;
    }
  };

  const updateAnchor = (anchor) => {
    if (!matchesQueenLife(anchor)) return;
    anchor.setAttribute('href', DESTINATION);
    anchor.dataset.sqQueenLifeRoute = 'true';
  };

  const apply = (root = document) => {
    root.querySelectorAll?.('#header-component a[href]').forEach(updateAnchor);
    if (root.matches?.('#header-component a[href]')) updateAnchor(root);
  };

  const start = () => {
    apply();
    const headerRoot = document.querySelector('#header-group') || document.documentElement;
    new MutationObserver((records) => {
      records.forEach((record) => {
        record.addedNodes.forEach((node) => {
          if (node instanceof Element) apply(node);
        });
      });
    }).observe(headerRoot, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', (event) => apply(event.target));
})();